import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { post } from "../js/post";
import "../css/OptometryScreen.css";
import "../css/Glasses.css";
import moment from "moment";
import {
  hearingAidRecordStructure,
  inputOnEnter,
  userData,
  selectedOptic,
  areObjectsEqual,
  focusElement,
  hearingAidsTypeOptions,
  calculateDiscountFromTotal,
} from "../js/utils";
import InputData from "./InputData";
import InputIconSearch from "./InputIconSearch";
import DropdownFilter from "./DropdownFilter";
import Dropdown from "./Dropdown";
import ButtonIconV from "./ButtonIconV";
import ButtonIconH from "./ButtonIconH";
import SummarySectionBox from "./SummarySectionBox";
import ActionPopup from "./ActionPopup";
import Insurance from "./Insurance";
import ObservationsPanel from "./ObservationsPanel";
import AssociateProduct from "./AssociateProduct";
import LoadingScreen from "./LoadingScreen";
import SalesManagement from "./SalesManagement";
import { calculateDtos } from "../js/calculateDtos";
import { getPatientProductPrice } from "../js/patientProductPrice";
import { useAgents } from "../hooks/useAgents";
import { useBrands } from "../hooks/useBrands";
import { useSuppliers } from "../hooks/useSuppliers";
import { useCampaigns } from "../hooks/useCampaigns";
import { useObservations } from "../hooks/useObservations";
import { useModelsTradeNamesAndProducts } from "../hooks/useModelsTradeNamesAndProducts";
import { HearingAidsReportPopup } from "./HearingAidsReportPopup";

export default function HearingAids({
  patientInfo,
  id,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
  onClickMenuOption,
}) {
  const [actionPopup, setActionPopup] = useState(null);
  const [dateHistoryList, setDateHistoryList] = useState([]);
  const [selectedDate, setSelectedDate] = useState({ id: "", text: "" });
  const [hearingAidsId, setHearingAidsId] = useState(id);
  const [currentHearingAids, setCurrentHearingAids] = useState(
    hearingAidRecordStructure,
  );
  const [currentHearingAidsEdit, setCurrentHearingAidsEdit] = useState(
    hearingAidRecordStructure,
  );
  const agentList = [{ id: "", text: "" }, ...useAgents()];
  const reasonList = [{ id: "", text: "" }, ...useCampaigns()];
  const [recordTypeList, setRecordTypeList] = useState([]);
  const [insurance, setInsurance] = useState({});
  const { list: observations, refresh: refreshObservations } = useObservations(
    currentHearingAidsEdit.idFicha,
    "Ficha",
  );
  const [actionComponent, setActionComponent] = useState(null);
  const [toggleObservationPanel, setToggleObservationPanel] = useState(false);
  const HASuppliers = useSuppliers(0)[0];
  const hearingAidsSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...HASuppliers.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [HASuppliers],
  );
  const chargerSuppliers = useSuppliers(5, "", "CARGADORES")[0];
  const chargerSupplierList = useMemo(
    () => [
      { id: -1, text: "" },
      ...chargerSuppliers.map((e) => ({ id: e.id, text: e.nombre })),
    ],
    [chargerSuppliers],
  );
  const [selectedRightHearingAidSupplier, setSelectedRightHearingAidSupplier] =
    useState({
      id: -1,
      text: "",
    });
  const [selectedLeftHearingAidSupplier, setSelectedLeftHearingAidSupplier] =
    useState({
      id: -1,
      text: "",
    });
  const [selectedChargerSupplier, setSelectedChargerSupplier] = useState({
    id: -1,
    text: "",
  });
  const rawLeftHearingAidBrandList = useBrands(
    0,
    selectedLeftHearingAidSupplier.id,
  )[0];
  const leftHearingAidBrandList = useMemo(() => {
    const brands = rawLeftHearingAidBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawLeftHearingAidBrandList]);

  const rawRightHearingAidBrandList = useBrands(
    0,
    selectedRightHearingAidSupplier.id,
  )[0];
  const rightHearingAidBrandList = useMemo(() => {
    const brands = rawRightHearingAidBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawRightHearingAidBrandList]);

  const rawChargerBrandList = useBrands(
    5,
    selectedChargerSupplier.id,
    "CARGADORES",
  )[0];
  const chargerBrandList = useMemo(() => {
    const brands = rawChargerBrandList.map((e) => ({ id: e, text: e }));
    return [{ id: "", text: "" }, ...brands];
  }, [rawChargerBrandList]);

  const rawRightHAModelsList = useModelsTradeNamesAndProducts(
    [0],
    selectedRightHearingAidSupplier.id,
    [currentHearingAidsEdit.datosAudifonoD.marca],
  )[0];
  const rightHAModelsList = useMemo(() => {
    const models = rawRightHAModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawRightHAModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawRightHAModelsList]);

  const rawLeftHAModelsList = useModelsTradeNamesAndProducts(
    [0],
    selectedLeftHearingAidSupplier.id,
    [currentHearingAidsEdit.datosAudifonoI.marca],
  )[0];
  const leftHAModelsList = useMemo(() => {
    const models = rawLeftHAModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawLeftHAModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawLeftHAModelsList]);

  const rawChargerModelsList = useModelsTradeNamesAndProducts(
    [5],
    selectedChargerSupplier.id,
    [currentHearingAidsEdit.cargador.marca],
    "CARGADORES",
  )[0];
  const chargerModelsList = useMemo(() => {
    const models = rawChargerModelsList.map((e) => ({ id: e, text: e }));
    // console.log(models, rawChargerModelsList);
    return [{ id: "", text: "" }, ...models];
  }, [rawChargerModelsList]);

  const [loadingData, setLoadingData] = useState(true);
  const [total, setTotal] = useState(0);
  // Alto del primer panel de la izquierda para igualar el de "Datos de la ficha"
  const [firstPanelHeight, setFirstPanelHeight] = useState(null);
  const firstPanelObserver = useRef(null);
  const firstPanelRef = useCallback((node) => {
    firstPanelObserver.current?.disconnect();
    firstPanelObserver.current = null;
    if (!node) return;
    const observer = new ResizeObserver(() => {
      setFirstPanelHeight(node.offsetHeight);
    });
    observer.observe(node);
    firstPanelObserver.current = observer;
  }, []);
  const [reportPopup, setReportPopup] = useState(false);

  // console.log("currentHearingAidsEdit: ", currentHearingAidsEdit);

  const getRecordTypeList = async () => {
    let response = await post("/support-extra/fichas/ListarTipoFichas.php", {
      token: userData.token,
      familia: 0,
    });
    setRecordTypeList([
      { id: "", text: "" },
      ...response.map((e) => ({ id: e.codigo, text: e.descripcion })),
    ]);
  };

  const getInsurance = async () => {
    const response = await post("/support-extra/fichas/ObtenerSeguro.php", {
      token: userData.token,
      idFicha: currentHearingAidsEdit.idFicha,
    });
    setInsurance(response);
  };

  const getHearingAidsHistory = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaAudifonos.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      const found = response.find((e) => {
        return e.idFichaAudifonos === hearingAidsId;
      });
      if (found) {
        setSelectedDate({
          id: found.idFichaAudifonos,
          text: found.fecha,
        });
        setHearingAidsId(found.idFichaAudifonos);
      }
    }
    setDateHistoryList(response);
  };

  const resetHearingAidsState = () => {
    setCurrentHearingAids({
      ...hearingAidRecordStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setCurrentHearingAidsEdit({
      ...hearingAidRecordStructure,
      fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setHearingAidsId(-1);
    setSelectedDate({
      id: -1,
      text: moment().format("YYYY-MM-DD HH:mm:ss"),
    });
    setSelectedRightHearingAidSupplier({ id: -1, text: "" });
    setSelectedLeftHearingAidSupplier({ id: -1, text: "" });
    setSelectedChargerSupplier({ id: -1, text: "" });
  };

  function showNotProductFoundMessage(code, index) {
    createPopupQuestion(
      `No existe ningún producto con el código ${code}.`,
      () => {
        removePopupQuestion();
        focusElement(index);
      },
      null,
      "Entendido",
    );
  }

  function showNotProductFoundCustomMessage(code, index, type) {
    createPopupQuestion(
      `No existe ningún producto de categoría ${type} con el código ${code}.`,
      () => {
        removePopupQuestion();
        focusElement(index);
      },
      null,
      "Entendido",
    );
  }

  function checkSaved() {
    createPopupQuestion(
      `Por favor, guarde la ficha primero.`,
      () => {
        removePopupQuestion();
      },
      null,
      "Entendido",
    );
  }

  const cloneHearingAids = async () => {
    const response = await post(
      "/support-extra/fichas/ClonarFichaAudifonos.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idFichaAudifonos: hearingAidsId,
      },
    );
    setHearingAidsId(parseInt(response.idFichaAudifonos));
  };

  const getProductPrice = (product) =>
    getPatientProductPrice({
      product,
      idPaciente: patientInfo?.id,
      createPopupQuestion,
      removePopupQuestion,
    });

  const searchHearingAidByCode = async (side, code) => {
    const key = side === 0 ? "datosAudifonoD" : "datosAudifonoI";
    let codigo = code || currentHearingAidsEdit[key].codigo;
    codigo = !codigo || codigo === "0" ? "00" : codigo;

    if (!codigo) return;

    const response = await fetchHearingAidData(codigo);

    if (!response?.id) {
      const index = side === 0 ? 61 : 77;
      showNotProductFoundMessage(codigo, index);
      return;
    }

    const nextIndex =
      side === 0 ? (codigo === "00" ? 62 : 77) : codigo === "00" ? 78 : 93;
    setTimeout(() => {
      focusElement(nextIndex);
    }, 100);

    const price = await getProductPrice(response);

    const updatedHearingAidData = mapHearingAidsData(
      currentHearingAidsEdit[key],
      response,
      price,
    );

    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      [key]: updatedHearingAidData,
    }));
  };

  const searchBatteryByCode = async (side, code) => {
    const key = side === 0 ? "datosAudifonoD" : "datosAudifonoI";
    const codigo = code || currentHearingAidsEdit[key].codigo;
    const category = "PILAS";

    if (!codigo) return;

    const response = await fetchVariousFamilyData(codigo, category);

    if (!response?.id) {
      const index = side === 0 ? 70 : 86;
      showNotProductFoundCustomMessage(codigo, index, category);
      return;
    }

    const nextIndex = side === 0 ? 71 : 87;
    focusElement(nextIndex);

    const updatedHearingAidData = {
      ...currentHearingAidsEdit[key],
      codigoPila: response.codigoOPTIWIN,
      pila: response.marca,
      idProveedorPila: response.idProveedor,
      nombreProveedorPila: response.nombreProveedor,
    };

    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      [key]: updatedHearingAidData,
    }));
  };

  const searchEarphoneByCode = async (side, code) => {
    const key = side === 0 ? "datosAudifonoD" : "datosAudifonoI";
    const codigo = code || currentHearingAidsEdit[key].codigo;
    const category = "AURICULAR";

    if (!codigo) return;

    const response = await fetchVariousFamilyData(codigo, category);

    if (!response?.id) {
      const index = side === 0 ? 72 : 88;
      showNotProductFoundCustomMessage(codigo, index, category);
      return;
    }

    const nextIndex = side === 0 ? 73 : 89;
    focusElement(nextIndex);

    const updatedHearingAidData = {
      ...currentHearingAidsEdit[key],
      codigoAuricular: response.codigoOPTIWIN,
      auricular: response.marca,
      idProveedorAuricular: response.idProveedor,
      nombreProveedorAuricular: response.nombreProveedor,
    };

    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      [key]: updatedHearingAidData,
    }));
  };

  const searchChargerByCode = async (code) => {
    let codigo = code || currentHearingAidsEdit.cargador.codigo;
    const category = "CARGADORES";
    codigo = !codigo || codigo === "0" ? "50" : codigo;

    if (!codigo) return;

    const response = await fetchVariousFamilyData(codigo, category);

    if (!response?.id) {
      const index = 93;
      showNotProductFoundCustomMessage(codigo, index, category);
      return;
    }

    const price = await getProductPrice(response);

    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      cargador: {
        ...prev.cargador,
        codigo: response.codigoOPTIWIN,
        nombreProveedor: response.nombreProveedor,
        idProveedor: response.idProveedor,
        marca: response.marca,
        modelo: response.producto,
        descuento: price.descuento,
        dtoMaximo: response.dtoMaximo,
        total: calculateLineTotal(price.pvp, price.descuento),
        pvp: price.pvp,
      },
    }));

    setTimeout(() => {
      focusElement(codigo === "50" ? 94 : 100);
    }, 100);
  };

  const fetchHearingAidData = async (codigo) => {
    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      idOptica: selectedOptic.id,
    };
    return await post("ObtenerAudifono.php", payload);
  };

  const fetchVariousFamilyData = async (codigo, category) => {
    const payload = {
      token: userData.token,
      codigo,
      tipoCodigo: -1,
      categoria: category,
      idOptica: selectedOptic.id,
    };
    const response = await post("ObtenerVarios.php", payload);
    return response;
  };

  const mapHearingAidsData = (currentHearingAidData, response, price) => ({
    ...currentHearingAidData,
    codigo: response.codigoOPTIWIN,
    proveedor: response.nombreProveedor,
    idProveedor: response.idProveedor,
    nSerie: response.numeroSerie,
    marca: response.marca,
    modelo: response.modelo,
    tipo: response.tipo,
    entreDb: response.entreDB,
    hastaDb: response.hastaDB,
    pvp: response.pvp,
    codigoPila: "",
    pila: "",
    idProveedorPila: "",
    nombreProveedorPila: "",
    codigoAuricular: "",
    auricular: "",
    idProveedorAuricular: "",
    nombreProveedorAuricular: "",
    descuento: price.descuento,
    dtoMaximo: response.dtoMaximo,
    total: calculateLineTotal(price.pvp, price.descuento),
    pvp: price.pvp,
  });

  const getHearingAids = async (id) => {
    const response = await post(
      "/support-extra/fichas/ObtenerFichaAudifonos.php",
      {
        token: userData.token,
        idFichaAudifonos: id,
        idOptica: selectedOptic.id,
      },
    );

    setCurrentHearingAids({
      ...response,
      idPaciente: patientInfo.id,
      idFichaAudifonos: id,
    });
    setCurrentHearingAidsEdit({
      ...response,
      idPaciente: patientInfo.id,
      idFichaAudifonos: id,
    });
  };

  const cancelChanges = async () => {
    if (dateHistoryList.length > 0) {
      // 1. Si estamos creando una ficha, cargamos la última.
      if (hearingAidsId === -1) {
        setSelectedDate({
          id: dateHistoryList[0].idFichaAudifonos,
          text: dateHistoryList[0].fecha,
        });
        setHearingAidsId(dateHistoryList[0].idFichaAudifonos);
        await getHearingAids(dateHistoryList[0].idFichaAudifonos);
      } else {
        // 2. Si estamos viendo una ficha, cancelamos los cambios.
        setCurrentHearingAidsEdit(currentHearingAids);
      }
    } else {
      setCurrentHearingAidsEdit(currentHearingAids);
    }
  };

  const deleteHearingAids = async () => {
    await post("/support-extra/fichas/EliminarFichaAudifonos.php", {
      token: userData.token,
      idFichaAudifonos: hearingAidsId,
      idUsuario: userData.id,
    });
  };

  const selectHearingAidsAfterDeleting = async () => {
    const response = await post(
      "/support-extra/fichas/ListarHistoricoFichaAudifonos.php",
      {
        token: userData.token,
        idPaciente: patientInfo.id,
        completo: 1,
      },
    );
    if (response.length > 0) {
      setSelectedDate({
        id: response[0].idFichaAudifonos,
        text: response[0].fecha,
      });
      setHearingAidsId(response[0].idFichaAudifonos);
      setDateHistoryList(response);
      await getHearingAids(response[0].idFichaAudifonos);
    } else {
      setSelectedDate({
        id: -1,
        text: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      setHearingAidsId(-1);
      setCurrentHearingAids(hearingAidRecordStructure);
      setCurrentHearingAidsEdit(hearingAidRecordStructure);
    }
  };

  const checkDiscount = (hearingAidsEdit = currentHearingAidsEdit) => {
    const checks = [
      {
        label: "del audífono derecho",
        data: hearingAidsEdit.datosAudifonoD,
        focusId: 75,
      },
      {
        label: "del audífono izquierdo",
        data: hearingAidsEdit.datosAudifonoI,
        focusId: 91,
      },
      {
        label: "del cargador",
        data: hearingAidsEdit.cargador,
        focusId: 98,
      },
    ];

    for (const { label, data, focusId } of checks) {
      if (data.dtoMaximo !== "" && data.descuento > data.dtoMaximo) {
        createPopupQuestion(
          `El descuento ${label} no puede ser mayor que su descuento máximo (${data.dtoMaximo}%).`,
          () => {
            removePopupQuestion();
            focusElement(focusId);
          },
          null,
          "Entendido",
        );
        return false;
      }
    }
    return true;
  };

  // Descuentos y precios se guardan como float con todos sus decimales (también
  // al enviarlos y recibirlos de los endpoints), pero los inputs los muestran
  // redondeados: el DTO a entero y los precios a céntimos. Por eso los inputs
  // no escriben en el estado al teclear, y al salir solo se recalcula si el
  // usuario ha cambiado el valor visible.
  const roundDto = (dto) => Math.round(parseFloat(dto) || 0);

  const roundPrice = (price) =>
    Math.round((parseFloat(price) || 0) * 100) / 100;

  const calculateLineTotal = (pvp, dto) =>
    (parseFloat(pvp) || 0) * (1 - (parseFloat(dto) || 0) / 100);

  const onBlurPrice = (e, section) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentHearingAidsEdit[section];
    if (inputValue === roundPrice(sectionData.pvp)) return;

    setCurrentHearingAidsEdit({
      ...currentHearingAidsEdit,
      [section]: {
        ...sectionData,
        pvp: inputValue,
        total: calculateLineTotal(inputValue, sectionData.descuento),
      },
    });
  };

  const onBlurDiscount = (e, section) => {
    const inputValue = Number(e) || 0;
    const sectionData = currentHearingAidsEdit[section];
    if (inputValue === roundDto(sectionData.descuento)) return;

    const hearingAidsEditN = {
      ...currentHearingAidsEdit,
      [section]: { ...sectionData, descuento: inputValue },
    };
    if (!checkDiscount(hearingAidsEditN)) {
      setCurrentHearingAidsEdit(hearingAidsEditN);
      return;
    }
    hearingAidsEditN[section].total = calculateLineTotal(
      sectionData.pvp,
      inputValue,
    );
    setCurrentHearingAidsEdit(hearingAidsEditN);
  };

  const onBlurLineTotal = (e, section, focusId) => {
    const sectionData = currentHearingAidsEdit[section];
    if (parseFloat(e) === roundPrice(sectionData.total)) return;

    const pvp = parseFloat(sectionData.pvp) || 0;
    if (pvp === 0) {
      const inputValue = Number(e) || 0;
      setCurrentHearingAidsEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          descuento: 0,
          pvp: inputValue,
          total: inputValue,
        },
      }));
      return;
    }

    const response = calculateDiscountFromTotal({
      pvp,
      total: e,
      dto: parseFloat(sectionData.descuento) || 0,
      dtoMax: sectionData.dtoMaximo,
      round: false,
    });
    const applyResponse = () =>
      setCurrentHearingAidsEdit((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          descuento: response.dto,
          total: response.total,
        },
      }));

    if (response.error !== "") {
      focusElement(focusId);
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
          applyResponse();
        },
        null,
        "Entendido",
      );
    } else {
      applyResponse();
    }
  };

  const saveHearingAids = async (onClose = () => {}) => {
    if (!checkDiscount()) return;
    if (validateData()) {
      const totalPrice = calculatePVP();
      const totalDiscount = calculateDiscount();
      const totalTotal = calculateTotal();
      const response = await post(
        "/support-extra/fichas/GuardarFichaAudifonos.php",
        {
          token: userData.token,
          idOptica: selectedOptic.id,
          idFichaAudifonos: hearingAidsId,
          idPaciente: patientInfo.id,
          ...currentHearingAidsEdit,
          precioTotal: totalTotal,
          dtoTotal: totalDiscount,
          pvptotal: totalPrice,
        },
      );

      if (!response.idFichaAudifonos) return;

      setSelectedDate({
        id: response.idFichaAudifonos,
        text: currentHearingAidsEdit.fechaCreacion,
      });
      setHearingAidsId(response.idFichaAudifonos);
      setCurrentHearingAidsEdit({
        ...currentHearingAidsEdit,
        idFichaAudifonos: response.idFichaAudifonos,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      setCurrentHearingAids({
        ...currentHearingAidsEdit,
        idFichaAudifonos: response.idFichaAudifonos,
        idFicha: response.idFicha,
        precioTotal: totalTotal,
        dtoTotal: totalDiscount,
        pvptotal: totalPrice,
      });
      createPopupQuestion(
        `Los cambios se han guardado con éxito.`,
        async () => {
          removePopupQuestion();
          setTimeout(() => {
            if (typeof onClose === "function") {
              onClose();
            }
          }, 0);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) y al menos una marca de alguno de los apartados antes de guardar la ficha.`,
        async () => {
          removePopupQuestion();
          focusRequiredField();
        },
        null,
        "Entendido",
      );
    }
  };

  const handleOpenActionPopup = (componentType) => {
    switch (componentType) {
      case "insurance":
        setActionComponent({
          name: "Seguro",
          component: (
            <Insurance
              id={currentHearingAidsEdit.idFicha}
              onClose={async () => {
                await getInsurance();
                setActionPopup(false);
              }}
            />
          ),
        });
        break;
      case "addRightHearingAids":
        setActionComponent({
          name: "Añadir audífono",
          component: (
            <AssociateProduct
              famId={0}
              supplier={selectedRightHearingAidSupplier}
              brand={currentHearingAidsEdit.datosAudifonoD.marca}
              onSelect={async (e) => {
                await searchHearingAidByCode(0, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLeftHearingAids":
        setActionComponent({
          name: "Añadir audífono",
          component: (
            <AssociateProduct
              famId={0}
              supplier={selectedLeftHearingAidSupplier}
              brand={currentHearingAidsEdit.datosAudifonoI.marca}
              onSelect={async (e) => {
                await searchHearingAidByCode(1, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addRightEarphone":
        setActionComponent({
          name: "Añadir auricular",
          component: (
            <AssociateProduct
              famId={5}
              category="AURICULAR"
              supplier={{ id: -1, text: "" }}
              brand={currentHearingAidsEdit.datosAudifonoD.auricular}
              onSelect={async (e) => {
                await searchEarphoneByCode(0, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLeftEarphone":
        setActionComponent({
          name: "Añadir auricular",
          component: (
            <AssociateProduct
              famId={5}
              category="AURICULAR"
              supplier={{ id: -1, text: "" }}
              brand={currentHearingAidsEdit.datosAudifonoI.auricular}
              onSelect={async (e) => {
                await searchEarphoneByCode(1, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addRightBattery":
        setActionComponent({
          name: "Añadir pila",
          component: (
            <AssociateProduct
              famId={5}
              category="PILAS"
              supplier={{ id: -1, text: "" }}
              brand={currentHearingAidsEdit.datosAudifonoD.pila}
              onSelect={async (e) => {
                await searchBatteryByCode(0, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addLeftBattery":
        setActionComponent({
          name: "Añadir pila",
          component: (
            <AssociateProduct
              famId={5}
              category="PILAS"
              supplier={{ id: -1, text: "" }}
              brand={currentHearingAidsEdit.datosAudifonoI.pila}
              onSelect={async (e) => {
                await searchBatteryByCode(1, e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "addCharger":
        setActionComponent({
          name: "Añadir cargador",
          component: (
            <AssociateProduct
              famId={5}
              category="CARGADORES"
              supplier={selectedChargerSupplier}
              brand={currentHearingAidsEdit.cargador.marca}
              onSelect={async (e) => {
                await searchChargerByCode(e);
                setActionPopup(false);
                setActionComponent(null);
              }}
            ></AssociateProduct>
          ),
        });
        break;
      case "sales":
        setActionComponent({
          name: "Venta · Encargo · Presupuesto · Proforma",
          component: (
            <SalesManagement
              id={currentHearingAidsEdit.idFicha}
              patientInfo={patientInfo}
              category={"audifonos"}
              products={{
                motivo: currentHearingAidsEdit.motivoAgente,
                prod1: {
                  ...currentHearingAidsEdit.datosAudifonoD,
                  totalPrecio: currentHearingAidsEdit.datosAudifonoD.total,
                },
                prod2: {
                  ...currentHearingAidsEdit.datosAudifonoI,
                  totalPrecio: currentHearingAidsEdit.datosAudifonoI.total,
                },
                prod3: {
                  ...currentHearingAidsEdit.cargador,
                  totalPrecio: currentHearingAidsEdit.cargador.total,
                },
              }}
              createPopupQuestion={createPopupQuestion}
              removePopupQuestion={removePopupQuestion}
              onClose={() => {
                setActionPopup(false);
                setActionComponent(null);
              }}
              onClickMenuOption={onClickMenuOption}
              onCloseCard={onCloseCard}
            ></SalesManagement>
          ),
        });
        break;
      default:
        setActionComponent(null);
    }
    setActionPopup(true);
  };

  function calculateTotal() {
    const valores = [
      currentHearingAidsEdit.datosAudifonoD.total,
      currentHearingAidsEdit.datosAudifonoI.total,
      currentHearingAidsEdit.cargador.total,
    ];

    return valores.reduce((acc, val) => {
      const num = parseFloat(val);
      return acc + (isNaN(num) ? 0 : num);
    }, 0);
  }

  function calculatePVP() {
    return (
      parseFloat(currentHearingAidsEdit.datosAudifonoD.pvp) +
      parseFloat(currentHearingAidsEdit.datosAudifonoI.pvp) +
      parseFloat(currentHearingAidsEdit.cargador.pvp)
    );
  }

  function calculateDiscount() {
    const discountAudifonoD =
      parseFloat(currentHearingAidsEdit.datosAudifonoD.pvp) -
      parseFloat(currentHearingAidsEdit.datosAudifonoD.total);
    const discountAudifonoI =
      parseFloat(currentHearingAidsEdit.datosAudifonoI.pvp) -
      parseFloat(currentHearingAidsEdit.datosAudifonoI.total);
    const discountCargador =
      parseFloat(currentHearingAidsEdit.cargador.pvp) -
      parseFloat(currentHearingAidsEdit.cargador.total);
    return discountAudifonoD + discountAudifonoI + discountCargador;
  }

  function focusRequiredField() {
    const fields = [
      { value: currentHearingAidsEdit.empleado, elementId: 100 },
      { value: currentHearingAidsEdit.tipoFicha, elementId: 101 },
      { value: currentHearingAidsEdit.datosAudifonoD.marca, elementId: 63 },
      { value: currentHearingAidsEdit.datosAudifonoI.marca, elementId: 79 },
      {
        value: currentHearingAidsEdit.cargador.marca,
        elementId: 95,
      },
    ];

    const emptyField = fields.find((field) => field.value === "");
    if (emptyField) {
      focusElement(emptyField.elementId);
    }
  }

  function validateData() {
    const fieldsToValidate = [
      currentHearingAidsEdit.empleado,
      currentHearingAidsEdit.tipoFicha,
    ];

    return (
      fieldsToValidate.every((field) => field !== "") &&
      (currentHearingAidsEdit.datosAudifonoD.marca !== "" ||
        currentHearingAidsEdit.datosAudifonoI.marca !== "" ||
        currentHearingAidsEdit.cargador.marca !== "")
    );
  }

  async function updateDiscounts(e) {
    let lines = [
      {
        total: currentHearingAidsEdit.datosAudifonoD.total,
        dto: currentHearingAidsEdit.datosAudifonoD.descuento,
        id: currentHearingAidsEdit.datosAudifonoD.codigo,
        dtoMax: currentHearingAidsEdit.datosAudifonoD.dtoMaximo,
      },
      {
        total: currentHearingAidsEdit.datosAudifonoI.total,
        dto: currentHearingAidsEdit.datosAudifonoI.descuento,
        id: currentHearingAidsEdit.datosAudifonoI.codigo,
        dtoMax: currentHearingAidsEdit.datosAudifonoI.dtoMaximo,
      },
      {
        total: currentHearingAidsEdit.cargador.total,
        dto: currentHearingAidsEdit.cargador.descuento,
        id: currentHearingAidsEdit.cargador.codigo,
        dtoMax: currentHearingAidsEdit.cargador.dtoMaximo,
      },
    ];

    const updatedLines = calculateDtos(lines, e, false, false);

    if (updatedLines.error !== "") {
      createPopupQuestion(
        updatedLines.error,
        () => {
          removePopupQuestion();
          setTotal(calculateTotal());
        },
        null,
        "Entendido",
      );
      return;
    }

    if (validateData()) {
      createPopupQuestion(
        "Se han ajustado los descuentos de forma automática.",
        async () => {
          removePopupQuestion();
          focusElement(61);

          if (updatedLines.lines.length >= 3) {
            setCurrentHearingAidsEdit((prev) => ({
              ...prev,
              datosAudifonoD: {
                ...prev.datosAudifonoD,
                descuento: updatedLines.lines[0].dto,
                total: updatedLines.lines[0].total,
              },
              datosAudifonoI: {
                ...prev.datosAudifonoI,
                descuento: updatedLines.lines[1].dto,
                total: updatedLines.lines[1].total,
              },
              cargador: {
                ...prev.cargador,
                descuento: updatedLines.lines[2].dto,
                total: updatedLines.lines[2].total,
              },
            }));
          }

          setTotal(e);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) y al menos una marca de alguno de los apartados y vuelva a establecer el total deseado.`,
        async () => {
          setTotal(calculateTotal());
          removePopupQuestion();
          focusRequiredField();
          return;
        },
        null,
        "Entendido",
      );
    }
  }

  const onCloseCard = () => {
    onClose();
  };

  const handleLeftOp = () => {
    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      datosAudifonoD: currentHearingAidsEdit.datosAudifonoI,
    }));
  };

  const handleRightOp = () => {
    setCurrentHearingAidsEdit((prev) => ({
      ...prev,
      datosAudifonoI: currentHearingAidsEdit.datosAudifonoD,
    }));
  };

  const printFile = async (data) => {
    if (hearingAidsId === -1) return;
    const response = await post(
      "/support-extra/gestionDocumental/GenerarFichaAudifonos.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idFichaAudifono: currentHearingAidsEdit.idFichaAudifonos,
        agente: userData.nombre + " " + userData.apellidos,
        tipoFicha: data.record,
        email: data.email,
        observaciones: data.observations,
      },
    );
    // console.log(
    // "GENERANDO: ",
    // {
    // token: userData.token,
    // idOptica: selectedOptic.id,
    // idFichaAudifono: currentHearingAidsEdit.idFichaAudifonos,
    // agente: userData.nombre + " " + userData.apellidos,
    // tipoFicha: data.record,
    // email: data.email,
    // observaciones: data.observations,
    // },
    // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ficha_audifono.pdf`;
      a.click();
    }
  };

  useEffect(() => {
    async function initData() {
      focusElement(61);
      await getHearingAidsHistory();
      await getRecordTypeList();
      if (hearingAidsId !== -1) {
        await getHearingAids(hearingAidsId);
      } else {
        setSelectedDate({
          id: -1,
          text: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        setCurrentHearingAidsEdit({
          ...currentHearingAidsEdit,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaAudifonos: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        });
        setCurrentHearingAids({
          ...currentHearingAids,
          fechaCreacion: moment().format("YYYY-MM-DD HH:mm:ss"),
          idFichaAudifonos: -1,
          empleado: userData.nombre + " " + userData.apellidos,
        });
      }
      setLoadingData(false);
    }
    initData();
  }, [hearingAidsId]);

  useEffect(() => {
    getInsurance();
  }, [currentHearingAidsEdit.idFicha]);

  useEffect(() => {
    if (actionComponent !== null) {
      setActionPopup(true);
    }
  }, [actionComponent]);

  useEffect(() => {
    if (
      hearingAidsSupplierList.length > 0 &&
      currentHearingAidsEdit.datosAudifonoD.proveedor !== ""
    ) {
      const found = hearingAidsSupplierList.find((e) => {
        return e.text === currentHearingAidsEdit.datosAudifonoD.proveedor;
      });

      setSelectedRightHearingAidSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [
    hearingAidsSupplierList,
    currentHearingAidsEdit.datosAudifonoD.proveedor,
  ]);

  useEffect(() => {
    if (
      hearingAidsSupplierList.length > 0 &&
      currentHearingAidsEdit.datosAudifonoI.proveedor !== ""
    ) {
      const found = hearingAidsSupplierList.find((e) => {
        return e.text === currentHearingAidsEdit.datosAudifonoI.proveedor;
      });

      setSelectedLeftHearingAidSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [
    hearingAidsSupplierList,
    currentHearingAidsEdit.datosAudifonoI.proveedor,
  ]);

  useEffect(() => {
    if (
      chargerSupplierList.length > 0 &&
      currentHearingAidsEdit.cargador.nombreProveedor !== ""
    ) {
      const found = chargerSupplierList.find((e) => {
        return e.text === currentHearingAidsEdit.cargador.nombreProveedor;
      });

      setSelectedChargerSupplier(
        found || {
          id: -1,
          text: "",
        },
      );
    }
  }, [chargerSupplierList, currentHearingAidsEdit.cargador.nombreProveedor]);

  useEffect(() => {
    setTotal(calculateTotal());
  }, [
    currentHearingAidsEdit.datosAudifonoD.total,
    currentHearingAidsEdit.datosAudifonoI.total,
    currentHearingAidsEdit.cargador.total,
  ]);

  return (
    <div className="popup-container">
      {actionPopup && (
        <ActionPopup
          name={actionComponent.name}
          children={actionComponent.component}
          onClose={() => {
            getInsurance();
            setActionPopup(false);
            setActionComponent(null);
          }}
        ></ActionPopup>
      )}
      {toggleObservationPanel && (
        <ObservationsPanel
          objectInfo={currentHearingAidsEdit.idFicha}
          category="Ficha"
          onClose={async () => {
            setToggleObservationPanel(false);
            refreshObservations();
          }}
        ></ObservationsPanel>
      )}
      {reportPopup && (
        <HearingAidsReportPopup
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
          onExport={async (data) => {
            // console.log("Datos exportación: ", data);
            await printFile(data);
          }}
          onClose={() => {
            setReportPopup(false);
          }}
        />
      )}
      <div className="popup-screen" style={{ maxHeight: "98%" }}>
        <div className="popup-screen-header">
          <button
            className="popup-action-icon close-icon"
            onClick={async () => {
              if (
                !areObjectsEqual(currentHearingAids, currentHearingAidsEdit)
              ) {
                createPopupQuestion(
                  "Existen cambios que no han sido guardados. ¿Desea guardar antes de salir?",
                  async () => {
                    removePopupQuestion();
                    await saveHearingAids(onClose);
                  },
                  () => {
                    removePopupQuestion();
                    onClose();
                  },
                  "Sí",
                  "No",
                );
              } else {
                onClose();
              }
              await getHearingAidsHistory();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span className="popup-screen-header-title">Ficha de audífonos</span>
        </div>
        {loadingData && (
          <div
            style={{
              minHeight: 960,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LoadingScreen message="Cargando ficha de audífonos..."></LoadingScreen>
          </div>
        )}
        {!loadingData && (
          <div
            className="tab-content background-gray"
            style={{
              padding: 0,
              gap: 10,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="popup-screen-actions"
              style={{ gap: 10, paddingBottom: 0 }}
            >
              <div className="popup-screen-box container-panel">
                <div className="popup-screen-box-info">
                  <div className="cell-extra">
                    <span className="label">Creación</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="datetime-local"
                        max="9999-12-31T23:59"
                        step="1"
                        tabIndex={104}
                        className="input-field input-cell"
                        value={currentHearingAidsEdit.fechaCreacion}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            fechaCreacion: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Entrega</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={105}
                        className="input-field"
                        value={currentHearingAidsEdit.fechaEntrega}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            fechaEntrega: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Actualización</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="datetime-local"
                        max="9999-12-31T23:59"
                        tabIndex={106}
                        readOnly={true}
                        className="input-field input-cell"
                        value={currentHearingAidsEdit.fechaActualizacion}
                        style={{
                          pointerEvents: "none",
                          cursor: "default",
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">Revisión</span>
                  </div>
                  <div className="cell-extra w-220">
                    <div className="input-data input-full">
                      <input
                        type="date"
                        max="9999-12-31"
                        tabIndex={107}
                        className="input-field"
                        value={currentHearingAidsEdit.fechaRevision}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            fechaRevision: e.target.value,
                          });
                        }}
                        onKeyUp={(e) => inputOnEnter(e)}
                      ></input>
                    </div>
                  </div>
                  <div className="cell-extra">
                    <span className="label">
                      Histórico ({dateHistoryList.length})
                    </span>
                  </div>
                  <div className="cell-extra w-100p">
                    <DropdownFilter
                      tabIndex={108}
                      selectedOptions={[]}
                      optionList={dateHistoryList.map((item) => ({
                        id: item.idFichaAudifonos,
                        text: moment(item.fecha, "YYYY-MM-DD HH:mm:ss").format(
                          "DD/MM/YYYY HH:mm:ss",
                        ),
                        active: selectedDate.id === item.idFichaAudifonos,
                      }))}
                      size={0}
                      op={moment(
                        selectedDate.text,
                        "YYYY-MM-DD HH:mm:ss",
                      ).format("DD/MM/YYYY HH:mm:ss")}
                      disabled={hearingAidsId === -1}
                      onChange={async (e) => {
                        setLoadingData(true);
                        setCurrentHearingAidsEdit(hearingAidRecordStructure);
                        setSelectedDate({
                          id: e.id,
                          text: moment(e.text, "DD/MM/YYYY HH:mm:ss").format(
                            "YYYY-MM-DD HH:mm:ss",
                          ),
                        });
                        setHearingAidsId(e.id);
                      }}
                    ></DropdownFilter>
                  </div>
                  <div className="selector-glasses-type combined-cells-2"></div>
                </div>
              </div>
              <div className="popup-screen-box container-panel">
                <ButtonIconV
                  text="Nuevo"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/create-blue.svg"
                      : "/images/create-gray.svg"
                  }
                  onClick={() => {
                    if (hearingAidsId !== -1) {
                      if (
                        !areObjectsEqual(
                          currentHearingAids,
                          currentHearingAidsEdit,
                        )
                      ) {
                        createPopupQuestion(
                          `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de crear una nueva ficha?`,
                          async () => {
                            await saveHearingAids();
                            removePopupQuestion();
                            resetHearingAidsState();
                          },
                          async () => {
                            removePopupQuestion();
                            resetHearingAidsState();
                          },
                          "Sí",
                          "No",
                        );
                      } else {
                        resetHearingAidsState();
                      }
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Reposición"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/clone-blue.svg"
                      : "/images/clone-gray.svg"
                  }
                  onClick={() => {
                    if (hearingAidsId !== -1) {
                      createPopupQuestion(
                        `¿Desea realizar reposición de esta ficha de audífonos?`,
                        async () => {
                          await cloneHearingAids();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Guardar"
                  icon="/images/save-blue.svg"
                  onClick={async () => {
                    await saveHearingAids();
                    await getHearingAidsHistory();
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Cancelar"
                  icon="/images/cancel-blue.svg"
                  onClick={() => {
                    if (
                      dateHistoryList.length === 0 &&
                      areObjectsEqual(
                        currentHearingAids,
                        currentHearingAidsEdit,
                      )
                    ) {
                      removePopupQuestion();
                    } else if (
                      !areObjectsEqual(
                        currentHearingAids,
                        currentHearingAidsEdit,
                      ) ||
                      hearingAidsId === -1
                    ) {
                      createPopupQuestion(
                        `¿Desea cancelar los cambios realizados?`,
                        async () => {
                          await cancelChanges();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Recargar"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/update-blue.svg"
                      : "/images/update-gray.svg"
                  }
                  onClick={() => {
                    if (hearingAidsId !== -1) {
                      createPopupQuestion(
                        `¿Desea recargar esta ficha de audífonos?`,
                        async () => {
                          await getHearingAids(hearingAidsId);
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Eliminar"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/remove-blue.svg"
                      : "/images/remove-gray.svg"
                  }
                  onClick={async () => {
                    if (hearingAidsId !== -1) {
                      createPopupQuestion(
                        `¿Desea eliminar esta ficha de audífonos?`,
                        async () => {
                          await deleteHearingAids();
                          await getHearingAidsHistory();
                          await selectHearingAidsAfterDeleting();
                          removePopupQuestion();
                        },
                        async () => {
                          removePopupQuestion();
                        },
                        "Sí",
                        "No",
                      );
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Imprimir"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/print-blue.svg"
                      : "/images/print-gray.svg"
                  }
                  onClick={() => {
                    if (hearingAidsId !== -1) {
                      setReportPopup(true);
                    }
                  }}
                ></ButtonIconV>
                <ButtonIconV
                  text="Finalizar"
                  icon={
                    hearingAidsId !== -1
                      ? "/images/shopping-cart-blue.svg"
                      : "/images/shopping-cart-gray.svg"
                  }
                  onClick={() => {
                    if (hearingAidsId !== -1) {
                      handleOpenActionPopup("sales");
                    } else {
                      checkSaved();
                    }
                  }}
                ></ButtonIconV>
              </div>
            </div>
            <div
              className="popup-screen-content"
              style={{ flex: 1, paddingBottom: 5 }}
            >
              <div
                className="popup-screen-content-col w-70 full-height"
                style={{ gap: 10 }}
              >
                <div className="container-panel" ref={firstPanelRef}>
                  <div className="opt-table-title">Datos audífono derecho</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código audífono
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={61}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={currentHearingAidsEdit.datosAudifonoD.codigo}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD:
                              hearingAidRecordStructure.datosAudifonoD,
                          });
                          setSelectedRightHearingAidSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(61);
                        }}
                        onEnter={() => {
                          searchHearingAidByCode(
                            0,
                            currentHearingAidsEdit.datosAudifonoD.codigo,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addRightHearingAids");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <ButtonIconH
                        text="Copiar a audífono izquierdo"
                        small
                        onClick={() => {
                          handleRightOp();
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={62}
                        optionList={hearingAidsSupplierList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoD.proveedor}
                        mandatory={false}
                        disabled={true}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              proveedor: e.text,
                            },
                          });
                          const supplierToSet = hearingAidsSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedRightHearingAidSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={63}
                        optionList={rightHearingAidBrandList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoD.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Código pila
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={70}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={currentHearingAidsEdit.datosAudifonoD.codigoPila}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              codigoPila: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              codigoPila: "",
                              pila: "",
                            },
                          });
                          focusElement(70);
                        }}
                        onEnter={() => {
                          searchBatteryByCode(
                            0,
                            currentHearingAidsEdit.datosAudifonoD.codigoPila,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir pila"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addRightBattery");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Modelo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={64}
                        optionList={rightHAModelsList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoD.modelo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              modelo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Pila
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={71}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoD.pila}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              pila: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={65}
                        optionList={hearingAidsTypeOptions}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoD.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              tipo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Código auricular
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={72}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={
                          currentHearingAidsEdit.datosAudifonoD.codigoAuricular
                        }
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              codigoAuricular: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              codigoAuricular: "",
                              auricular: "",
                            },
                          });
                          focusElement(72);
                        }}
                        onEnter={() => {
                          searchEarphoneByCode(
                            0,
                            currentHearingAidsEdit.datosAudifonoD
                              .codigoAuricular,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir auricular"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addRightEarphone");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nº serie
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={66}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoD.nSerie}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              nSerie: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Auricular
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={73}
                        maxLength={50}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoD.auricular}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              auricular: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Rango dB
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={67}
                        type="type-integer"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoD.entreDb}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              entreDb: e,
                            },
                          });
                        }}
                      ></InputData>
                      <InputData
                        tabIndex={68}
                        type="type-integer"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoD.hastaDb}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoD: {
                              ...currentHearingAidsEdit.datosAudifonoD,
                              hastaDb: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={74}
                            type="type-positive-float"
                            size={6}
                            input={currentHearingAidsEdit.datosAudifonoD.pvp}
                            onChange={() => {}}
                            onBlur={(e) => onBlurPrice(e, "datosAudifonoD")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO %
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={75}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentHearingAidsEdit.datosAudifonoD.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) => onBlurDiscount(e, "datosAudifonoD")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={76}
                            type="type-positive-float"
                            size={6}
                            input={currentHearingAidsEdit.datosAudifonoD.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(e, "datosAudifonoD", 76)
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container-panel">
                  <div className="opt-table-title">
                    Datos audífono izquierdo
                  </div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código audífono
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={77}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={currentHearingAidsEdit.datosAudifonoI.codigo}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI:
                              hearingAidRecordStructure.datosAudifonoI,
                          });
                          setSelectedLeftHearingAidSupplier({
                            id: -1,
                            text: "",
                          });
                          focusElement(77);
                        }}
                        onEnter={() => {
                          searchHearingAidByCode(
                            1,
                            currentHearingAidsEdit.datosAudifonoI.codigo,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLeftHearingAids");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Opciones
                    </div>
                    <div
                      className="cell"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <ButtonIconH
                        text="Copiar a audífono derecho"
                        small
                        onClick={() => {
                          handleLeftOp();
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={78}
                        optionList={hearingAidsSupplierList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoI.proveedor}
                        mandatory={false}
                        disabled={true}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              proveedor: e.text,
                            },
                          });
                          const supplierToSet = hearingAidsSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedLeftHearingAidSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={79}
                        optionList={leftHearingAidBrandList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoI.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Código pila
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={86}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={currentHearingAidsEdit.datosAudifonoI.codigoPila}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              codigoPila: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              codigoPila: "",
                              pila: "",
                            },
                          });
                          focusElement(86);
                        }}
                        onEnter={() => {
                          searchBatteryByCode(
                            1,
                            currentHearingAidsEdit.datosAudifonoI.codigoPila,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir pila"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLeftBattery");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Modelo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={80}
                        optionList={leftHAModelsList}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoI.modelo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              modelo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Pila
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={87}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoI.pila}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              pila: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Tipo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={81}
                        optionList={hearingAidsTypeOptions}
                        size={0}
                        op={currentHearingAidsEdit.datosAudifonoI.tipo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              tipo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Código auricular
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={88}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={
                          currentHearingAidsEdit.datosAudifonoI.codigoAuricular
                        }
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              codigoAuricular: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              codigoAuricular: "",
                              auricular: "",
                            },
                          });
                          focusElement(88);
                        }}
                        onEnter={() => {
                          searchEarphoneByCode(
                            1,
                            currentHearingAidsEdit.datosAudifonoI
                              .codigoAuricular,
                          );
                        }}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir auricular"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addLeftEarphone");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Nº serie
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={82}
                        maxLength={40}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoI.nSerie}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              nSerie: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Auricular
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={89}
                        maxLength={50}
                        type="type-alphanum-ext"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoI.auricular}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              auricular: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Rango dB
                    </div>
                    <div className="cell">
                      <InputData
                        tabIndex={83}
                        type="type-integer"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoI.entreDb}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              entreDb: e,
                            },
                          });
                        }}
                      ></InputData>
                      <InputData
                        tabIndex={84}
                        type="type-integer"
                        size={0}
                        input={currentHearingAidsEdit.datosAudifonoI.hastaDb}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            datosAudifonoI: {
                              ...currentHearingAidsEdit.datosAudifonoI,
                              hastaDb: e,
                            },
                          });
                        }}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="opt-table-content grid-8-summary">
                        <div className="cell cell-label cell-start-content">
                          PVP
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={90}
                            type="type-positive-float"
                            size={6}
                            input={currentHearingAidsEdit.datosAudifonoI.pvp}
                            onChange={() => {}}
                            onBlur={(e) => onBlurPrice(e, "datosAudifonoI")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          DTO %
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={91}
                            type="type-positive-integer"
                            size={6}
                            input={roundDto(
                              currentHearingAidsEdit.datosAudifonoI.descuento,
                            )}
                            onChange={() => {}}
                            onBlur={(e) => onBlurDiscount(e, "datosAudifonoI")}
                          ></InputData>
                        </div>
                        <div className="cell"></div>
                        <div className="cell cell-label cell-start-content">
                          Total
                        </div>
                        <div className="cell">
                          <InputData
                            tabIndex={92}
                            type="type-positive-float"
                            size={6}
                            input={currentHearingAidsEdit.datosAudifonoI.total}
                            onChange={() => {}}
                            onBlur={(e) =>
                              onBlurLineTotal(e, "datosAudifonoI", 92)
                            }
                          ></InputData>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container-panel" style={{ flex: 1 }}>
                  <div className="opt-table-title">Datos cargador</div>
                  <div
                    className="opt-table-content grid-5"
                    id="glasses-content-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Código cargador
                    </div>
                    <div className="cell cell-start-content">
                      <InputIconSearch
                        tabIndex={93}
                        type="type-alphanum-ext"
                        size={6}
                        maxLength={10}
                        input={currentHearingAidsEdit.cargador.codigo}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            cargador: {
                              ...currentHearingAidsEdit.cargador,
                              codigo: e,
                            },
                          });
                        }}
                        onClear={() => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            cargador: hearingAidRecordStructure.cargador,
                          });
                          setSelectedChargerSupplier({ id: -1, text: "" });
                          focusElement(93);
                        }}
                        onEnter={searchChargerByCode}
                      ></InputIconSearch>
                      <ButtonIconH
                        text="Añadir"
                        small
                        onClick={() => {
                          handleOpenActionPopup("addCharger");
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2 cell-start-content"></div>
                    <div className="cell cell-label cell-start-content">
                      Proveedor
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={94}
                        optionList={chargerSupplierList}
                        size={0}
                        op={currentHearingAidsEdit.cargador.nombreProveedor}
                        mandatory={false}
                        disabled={true}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            cargador: {
                              ...currentHearingAidsEdit.cargador,
                              nombreProveedor: e.text,
                            },
                          });
                          const supplierToSet = chargerSupplierList.find(
                            (supplier) => supplier.id === e.id,
                          ) ?? {
                            id: -1,
                            text: "",
                          };
                          setSelectedChargerSupplier(supplierToSet);
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Marca
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={95}
                        optionList={chargerBrandList}
                        size={0}
                        op={currentHearingAidsEdit.cargador.marca}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            cargador: {
                              ...currentHearingAidsEdit.cargador,
                              marca: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell combined-cells-3"></div>
                    <div className="cell cell-label cell-start-content">
                      Modelo
                    </div>
                    <div className="cell">
                      <Dropdown
                        tabIndex={96}
                        optionList={chargerModelsList}
                        size={0}
                        op={currentHearingAidsEdit.cargador.modelo}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            cargador: {
                              ...currentHearingAidsEdit.cargador,
                              modelo: e.text,
                            },
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell combined-cells-2">
                      <div className="cell combined-cells-2">
                        <div className="opt-table-content grid-8-summary">
                          <div className="cell cell-label cell-start-content">
                            PVP
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={97}
                              type="type-positive-float"
                              size={6}
                              input={currentHearingAidsEdit.cargador.pvp}
                              onChange={() => {}}
                              onBlur={(e) => onBlurPrice(e, "cargador")}
                            ></InputData>
                          </div>
                          <div className="cell"></div>
                          <div className="cell cell-label cell-start-content">
                            DTO %
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={98}
                              type="type-positive-integer"
                              size={6}
                              input={roundDto(
                                currentHearingAidsEdit.cargador.descuento,
                              )}
                              onChange={() => {}}
                              onBlur={(e) => onBlurDiscount(e, "cargador")}
                            ></InputData>
                          </div>
                          <div className="cell"></div>
                          <div className="cell cell-label cell-start-content">
                            Total
                          </div>
                          <div className="cell">
                            <InputData
                              tabIndex={99}
                              type="type-positive-float"
                              size={6}
                              input={currentHearingAidsEdit.cargador.total}
                              onChange={() => {}}
                              onBlur={(e) => onBlurLineTotal(e, "cargador", 99)}
                            ></InputData>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="popup-screen-content-col w-30"
                style={{ gap: 10, alignSelf: "stretch" }}
              >
                <div
                  className="container-panel glasses-record-panel"
                  style={
                    firstPanelHeight ? { height: firstPanelHeight } : undefined
                  }
                >
                  <div className="opt-table-title">Datos de la ficha</div>
                  <div className="opt-table-content grid-8">
                    <div className="cell cell-label combined-cells-2 cell-start-content">
                      Agente (*)
                    </div>
                    <div className="cell cell-label combined-cells-6 cell-start-content">
                      <Dropdown
                        tabIndex={100}
                        optionList={agentList}
                        size={0}
                        op={currentHearingAidsEdit.empleado}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            empleado: e.text,
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label combined-cells-2 cell-start-content">
                      Tipo ficha (*)
                    </div>
                    <div className="cell cell-label combined-cells-6 cell-start-content">
                      <Dropdown
                        tabIndex={101}
                        optionList={recordTypeList}
                        size={0}
                        mandatory={true}
                        op={currentHearingAidsEdit.tipoFicha}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            tipoFicha: e.id,
                          });
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell cell-label combined-cells-2 cell-start-content">
                      Motivo
                    </div>
                    <div className="cell cell-label combined-cells-6 cell-start-content">
                      <Dropdown
                        tabIndex={102}
                        optionList={reasonList}
                        size={0}
                        op={currentHearingAidsEdit.motivoAgente}
                        mandatory={false}
                        onChange={(e) => {
                          setCurrentHearingAidsEdit({
                            ...currentHearingAidsEdit,
                            motivoAgente: e.id,
                          });
                        }}
                      ></Dropdown>
                    </div>
                  </div>
                  <div className="glasses-total-row">
                    <span className="glasses-total-label">TOTAL</span>
                    <div className="glasses-total-value">
                      <InputData
                        tabIndex={103}
                        type="type-positive-float"
                        size={6}
                        input={total}
                        onChange={() => {}}
                        onBlur={async (e) => {
                          const value = parseFloat(e);
                          if (isNaN(value) || value === roundPrice(total)) {
                            return;
                          }
                          await updateDiscounts(value);
                        }}
                      ></InputData>
                      €
                    </div>
                  </div>
                </div>
                <div className="container-panel glasses-sections-panel">
                  <SummarySectionBox
                    row
                    name="Observaciones"
                    numElements={observations.length}
                    onOpen={() => {
                      if (hearingAidsId !== -1) {
                        setToggleObservationPanel(true);
                      } else {
                        checkSaved();
                      }
                    }}
                  ></SummarySectionBox>
                  <SummarySectionBox
                    row
                    name="Seguro"
                    active={
                      Object.keys(insurance).length > 0 &&
                      insurance.tipoSeguro !== "N"
                    }
                    onOpen={() => {
                      if (hearingAidsId !== -1) {
                        handleOpenActionPopup("insurance");
                      } else {
                        checkSaved();
                      }
                    }}
                  ></SummarySectionBox>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
